<template>
  <div
    :class="{
      'text-center': !inline,
    }"
  >
    <div
      :class="{
        'my-48': !inline && !label,
        'inline-block': inline,
      }"
    >
      <i class="fas fa-circle-notch fa-spin" :class="{ 'fa-2x': !small }" />
    </div>
    <div
      v-if="label"
      class="mt-3 text-center"
      :class="{ 'ml-2 inline': inline }"
    >
      {{ label }}
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  inline: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: null,
  },
  small: {
    type: Boolean,
    default: false,
  },
});
</script>
